import './index.sass';

export default () => {
  $(document).on('click', '.button-flag', function(e, data){
    const self = this;
    $('body').css('overflow', 'hidden');
    $('#modal-container').html($('#modal-spam').html());
    $('#modal-container').find('.js-button-ok').click(() => {

      $.ajax({
        url: $(self).attr('href'),
        headers: {"X-CSRF-Token": $('meta[name=csrf-token]').attr('content')},
        type: "POST",
        success: function(res) {
          $('.modal-close').trigger('click')
        },
        error: function(res) {
          console.log(res.status);
        }
      })
    });
    return false;
  });
}